export { default } from "./ClientCredentials";
